
    import {defineComponent, reactive, toRefs, ComputedRef, computed, watch} from 'vue';
    import {useStore} from "@/store";
    import bannerModel from "@/views/h5/_components/bannerModel.vue";

    interface CheckItemShow {
        Accident: boolean;
        Fire: boolean;
        SoakWater: boolean;
        Appearance: boolean;
        Interior: boolean;
        Lighting: boolean;
        Machine: boolean;
        Power: boolean;
        Bottom: boolean;
        StartUp: boolean;
    }

    interface Item {
        checkItemCode: string;
        checkItemName: string;
        itemDesc: string;
        photoList: object[];
    }

    interface State {
        listName: string; // 列表名称
        listDefectNumber: number; // 总计标红的数量
        listSumNumber: number; // 总计检查项的数量
        importantNumber: number; // 总计重要检查项的数量
        defectList: Item[]; // 列表数据
        isShowAll: boolean; // 是否展开折叠
        isShowModel: boolean; // 是否打开弹框
        showPhotoList: object[]; // 弹框banner展示图片列表
        checkItemShow: CheckItemShow;
    }

    export default defineComponent({
        name: "defectList",
        props: {
            defectData: {
                type: Object,
                default: () => {
                    return {};
                }
            }
        },
        setup(props) {
            let state: State = reactive({
                listName: '',
                listDefectNumber: 0,
                listSumNumber: 0,
                importantNumber: 0,
                defectList: [],
                isShowAll: false,
                isShowModel: false,
                showPhotoList: [],
                checkItemShow: {
                    Accident: false,
                    Fire: false,
                    SoakWater: false,
                    Appearance: false,
                    Interior: false,
                    Lighting: false,
                    Machine: false,
                    Power: false,
                    Bottom: false,
                    StartUp: false,
                }
            })
            function SET_STATE(payload: any) {
                Object.keys(payload).forEach((key: string) => {
                    if (typeof payload[key] !== 'undefined') {
                        state[key] = payload[key];
                    }
                })
            }
            const {defectData} = toRefs(props)
            SET_STATE(defectData.value)
            let store = useStore()
            let checkItemShow: ComputedRef<{}> = computed<{}>(() => store.state.checkItemShow)
            watch(checkItemShow, (data: any) => {
                const {checkItemShow} = data;
                state.checkItemShow = checkItemShow
                if (state.listName === '事故检测') {
                    state.isShowAll = checkItemShow.Accident
                }
                if (state.listName === '火烧检测') {
                    state.isShowAll = checkItemShow.Fire
                }
                if (state.listName === '泡水检测') {
                    state.isShowAll = checkItemShow.SoakWater
                }
                if (state.listName === '外观检测') {
                    state.isShowAll = checkItemShow.Appearance
                }
                if (state.listName === '内饰检测') {
                    state.isShowAll = checkItemShow.Interior
                }
                if (state.listName === '灯光及电器检测') {
                    state.isShowAll = checkItemShow.Lighting
                }
                if (state.listName === '启动检测') {
                    state.isShowAll = checkItemShow.StartUp
                }
                if (state.listName === '动力检测') {
                    state.isShowAll = checkItemShow.Power
                }
                if (state.listName === '机舱检测') {
                    state.isShowAll = checkItemShow.Machine
                }
                if (state.listName === '底盘检测') {
                    state.isShowAll = checkItemShow.Bottom
                }
            })
            return {
                state,
                store
            }
        },
        methods: {
            // 获取状态
            handleStatus(signRuleVOS: any) {
                let signone: any = [], signtwo: any = [], backStatus: any = ''
                signRuleVOS.map((item: any) => {
                    if (item.sign == 1) {
                        signone.push(item.congValue)
                    } else {
                        signtwo.push(item.congValue)
                    }
                })
                if (signone.length > 0) {
                    backStatus = 0
                }
                if (signtwo.length > 0) {
                    backStatus = 0
                }
                if (signone.length > 0 && signtwo.length > 0) {
                    backStatus = 1
                }
                return backStatus
            },
            handleSignStatus(signRuleVOS: any) {
                let signone: any = [], signtwo: any = [], backValue = '', name = ''
                signRuleVOS.map((item: any) => {
                    if(item.sign == 1) {
                      signone.push(item.congValue)
                    } else {
                      signtwo.push(item.congValue)
                    }
                })
                if (this.state.listName == '事故检测') {
                    name = '重大事故'
                } else if (this.state.listName == '火烧检测' || this.state.listName == '泡水检测') {
                    name = this.state.listName.substring(0, 2)
                } else {
                    name = '瑕疵'
                }
                if (signone.length > 0) {
                    backValue = '非' + name + '(' + signone.join('、') + ')'
                    backValue = this.handleBreakLine(backValue)
                }
                if (signtwo.length > 0) {
                    backValue = name + '(' + signtwo.join('、') + ')'
                    backValue = this.handleBreakLine(backValue)
                }
                if (signone.length > 0 && signtwo.length > 0) {
                    let oneword: string = name + '(' + this.handleBreakLine(signtwo.join('、')) + ')',
                    twoword: string = '非'+ name + '(' + this.handleBreakLine(signone.join('、')) + ')'
                    backValue = this.handleBreakLine(oneword) + '\n' + this.handleBreakLine(twoword)
                }
                return backValue
            },
            handleBreakLine(word: string) {
                if (word.length <= 11) {
                    return word
                } else if (word.length > 11 && word.length <= 22) {
                    return word.substring(0, 11) + '\n' + word.substring(11)
                } else if (word.length > 22 && word.length <= 33) {
                    return word.substring(0, 11) + '\n' + word.substring(11, 22) + '\n' + word.substring(22)
                } else {
                    return word.substring(0, 11) + '\n' + word.substring(11, 22) + '\n' + word.substring(22, 33) + '\n' + '...'
                }
            },
            changeIsShowAllState() {
                this.state.isShowAll = !this.state.isShowAll
                if (this.state.listName === "事故检测") {
                    this.state.checkItemShow.Accident = this.state.isShowAll
                }
                if (this.state.listName === "火烧检测") {
                    this.state.checkItemShow.Fire = this.state.isShowAll
                }
                if (this.state.listName === "泡水检测") {
                    this.state.checkItemShow.SoakWater = this.state.isShowAll
                }
                if (this.state.listName === "外观检测") {
                    this.state.checkItemShow.Appearance = this.state.isShowAll
                }
                if (this.state.listName === "内饰检测") {
                    this.state.checkItemShow.Interior = this.state.isShowAll
                }
                if (this.state.listName === "灯光及电器检测") {
                    this.state.checkItemShow.Lighting = this.state.isShowAll
                }
                if (this.state.listName === "启动检测") {
                    this.state.checkItemShow.StartUp = this.state.isShowAll
                }
                if (this.state.listName === "动力检测") {
                    this.state.checkItemShow.Power = this.state.isShowAll
                }
                if (this.state.listName === "机舱检测") {
                    this.state.checkItemShow.Machine = this.state.isShowAll
                }
                if (this.state.listName === "底盘检测") {
                    this.state.checkItemShow.Bottom = this.state.isShowAll
                }
                this.store.dispatch('saveCheckItemShow', {checkItemShow: this.state.checkItemShow})
            },
            showItemPhoto(item: any) {
                if (item.photoList && item.photoList.length > 0) {
                    // 唤起缺陷照轮播组件
                    this.state.showPhotoList = item.photoList
                    this.state.isShowModel = true
                    document.body.style.overflow = "hidden" 
                }
            },
            closeModel(){
                this.state.isShowModel = false
                document.body.style.overflow = "" 
            }
        },
        components: {
            bannerModel
        }
    })
